export { default } from './Post.component';
